import React from 'react'
import PropTypes from 'prop-types'

import Ingredients from './Ingredients'

const IngredientGroups = ({ data, check }) => {
  let ingredientGroups = data.map((group, i) => (
    <div className="ingredient-group" dir="auto" key={ i } >
      { (group.title) ? <h4>{ group.title }</h4> : null }
      <Ingredients data={ group.ingredients } check={ check }/>
    </div>
  ));

  return (
    <div className="ingredient-groups" dir="auto">
      { ingredientGroups }
    </div>
  );
};

IngredientGroups.PropTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    ingredients: PropTypes.object.isRequired,
  }).isRequired).isRequired
};

export default IngredientGroups;



// WEBPACK FOOTER //
// ./modules/recipe/components/IngredientGroups.js